import React from 'react';
export function SavingsCalculator() {
  return <section className="py-5 md:py-7 px-4 bg-[#F7F5F0] text-text-primary" data-id="element-162">
      <div className="max-w-4xl mx-auto text-center" data-id="element-163">
        <h2 className="text-xl md:text-3xl mb-4 md:mb-5 font-bold tracking-tight" data-id="element-164">
          Hacemos un cálculo rápido…
        </h2>

        <div className="bg-white border border-black/10 p-4 md:p-6 rounded-2xl shadow-sm" data-id="element-165">
          <p className="text-sm md:text-lg mb-3 md:mb-4 font-medium text-text-primary/90" data-id="element-166">
            Si pedís delivery 5 veces por semana:
          </p>

          <div className="space-y-2 md:space-y-3 mb-5 md:mb-6 text-sm md:text-base font-medium" data-id="element-167">
            <p data-id="element-168">
              Promedio por pedido:{' '}
              <span className="font-bold text-danger" data-id="element-169">$20.000 ARS</span>
            </p>
            <p data-id="element-170">
              Eso son más de{' '}
              <span className="font-bold text-danger underline decoration-danger decoration-2 underline-offset-4" data-id="element-171">
                $400.000 al mes.
              </span>
            </p>
          </div>

          <div className="bg-[#F7F5F0] text-text-primary p-3 md:p-5 border border-primary/20 rounded-2xl" data-id="element-172">
            <p className="text-sm md:text-lg font-bold mb-1.5 md:mb-2 tracking-tight" data-id="element-173">
              Con este sistema podés ahorrar fácilmente
            </p>
            <p className="text-xl md:text-4xl font-black text-primary mb-1.5 md:mb-2 tracking-tight" data-id="element-174">
              más de $300.000 mensuales.
            </p>
            <p className="text-xs md:text-sm text-text-primary/80 font-medium" data-id="element-175">
              La inversión se paga sola en la primera semana y empezás a cuidar
              tu salud.
            </p>
          </div>
        </div>
      </div>
    </section>;
}